import { Modal } from "@mui/material";
import * as React from "react";
import { useContext } from "react";
import ImageUploader from "react-images-upload";
import { Context } from "../../../../Context/context";

export const ImageUpload = () => {
  const { state, dispatch } = useContext(Context);

  const handleUpload = (_files: File[], pictures: string[]) => {
    if (pictures.length !== 1) return;
    const imageName = Date.now().toString();
    try {
      var image = { src: pictures[0]}
      dispatch({ type: "set_image", value: [imageName, image ] });
      dispatch({ type: "set_shape_images", value: imageName });        
    } catch (e) {
        console.info("Image Load error : " + e )
    }
    dispatch({ type: "close_imagemodal", value: false });
  };

  return (
    <div>
      <Modal
        open={state.imageModalOpen}
        aria-labelledby="Image Upload"
        aria-describedby="Image Upload"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9000000000,
        }}
      >
        <div
          style={{
            margin: "0 auto",
            width: "50%",
          }}
        >
          <ImageUploader
            withIcon={true}
            style={{ display: state.imageModalOpen ? "block" : "none" }}
            buttonText="Choose image"
            onChange={handleUpload}
            imgExtension={[".jpg", ".gif", ".png", ".gif"]}
            singleImage
          />
          <div
            onClick={() => {
              dispatch({
                type: "close_imagemodal",
                value: false,
              });
            }}
            id="uploadExit"
            style={{
              backgroundColor:"#FFFFFF",
              position: "absolute",
              fontSize: "28px",
              bottom: "53%",
              marginLeft: "20px",
              cursor: "pointer",
              width: "50px",
              height: "50px",
            }}
          >
            X
          </div>
        </div>
      </Modal>
    </div>
  );
};
